import React from 'react';

const MyInputHTMLImage = (props) => {
  const {
    block,
    className,
    contentState,
    // theme = {},
    ...otherProps
  } = props;

  // leveraging destructuring to omit certain properties from props
  const {
    blockProps, // eslint-disable-line no-unused-vars
    customStyleMap, // eslint-disable-line no-unused-vars
    customStyleFn, // eslint-disable-line no-unused-vars
    decorator, // eslint-disable-line no-unused-vars
    forceSelection, // eslint-disable-line no-unused-vars
    offsetKey, // eslint-disable-line no-unused-vars
    selection, // eslint-disable-line no-unused-vars
    tree, // eslint-disable-line no-unused-vars
    blockStyleFn, // eslint-disable-line no-unused-vars
    ...elementProps
  } = otherProps;

  const { src, subtitle } = contentState.getEntity(block.getEntityAt(0)).getData();

  return (
    <div style={{ textAlign: 'center' }}>
      <img
        style={{ maxHeight: 150, width: '100%', objectFit: 'contain' }}
        src={src}
        alt={subtitle}
        role="presentation"
        className={className}
        {...elementProps}
      />
    </div>
  );
};

export default MyInputHTMLImage;
